<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-toolbar>
	<div class="left-side">
		<!-- <globalictcc-button
			[iconOnly]="true"
			iconName="hub"
		/> -->

		<div class="logo">
			<img
				src="images/ntt-logo.svg"
				alt="Logo"
			/>

			<span class="ellipse-divider">·</span>

			<span class="app-name">ICT CARBON INSIGHTS</span>
		</div>
	</div>

	<img
		src="images/projectone-logo.svg"
		alt="Logo"
	/>

	<div class="right-side">
		<globalictcc-popover>
			<globalictcc-button
				popover-trigger
				[iconOnly]="true"
				iconName="settings"
			/>

			<div
				popover-template
				class="popover-content"
			>
				<span class="popover-title">Settings</span>

				<globalictcc-toggle
					[checked]="isAppAccessible"
					(handleToggleChange)="onToggleAccessibility($event)"
					>Visualise text alternative</globalictcc-toggle
				>
			</div>
		</globalictcc-popover>

		<!-- <globalictcc-button
			[iconOnly]="true"
			iconName="notification"
			[hasBadge]="hasUnreadNotifications"
		/> -->

		<globalictcc-popover>
			<globalictcc-profile
				popover-trigger
				profilePicUrl="images/generic-user-icon.png"
				[username]="username"
				[role]="role"
			/>

			<div
				popover-template
				class="popover-content"
			>
				<span class="popover-title">Profile</span>

				<globalictcc-button
					class="logout-button"
					label="Logout"
					iconName="emitter"
					[textOnly]="true"
					(handleClick)="onLogout()"
				/>
			</div>
		</globalictcc-popover>
	</div>
</mat-toolbar>
